export default function ScreenCapturePickerView() {
    return null;
}
